import React from "react";

import EditIcon from "@mui/icons-material/Edit";

function EditButton(props) {
  return (
    <div
      className="square-button check-button-color centered-content button-pointer"
      title="Edit"
      onClick={props.handleOpen}
    >
      <EditIcon style={{ color: "white" }} />
      {/* <span className="tooltip-text">{props.title}</span> */}
    </div>
  );
}

export default EditButton;
